export default "__VITE_ASSET__C58rVW5Q__"